var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoUser = function SvgIcoUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 85",
    d: "M0 0h24v24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 9",
    d: "m5.533 19.622-.021-.018A9.981 9.981 0 0 1 2 12 10.012 10.012 0 0 1 12 2a10.012 10.012 0 0 1 10 10 9.977 9.977 0 0 1-3.426 7.53.974.974 0 0 1-.187.159A9.958 9.958 0 0 1 12 22a9.958 9.958 0 0 1-6.467-2.378Zm6.466.379a7.961 7.961 0 0 0 4.617-1.469A3.026 3.026 0 0 0 14 17h-4a2.977 2.977 0 0 0-2.617 1.531A7.956 7.956 0 0 0 12 20Zm2-5a4.95 4.95 0 0 1 2.985.991 4.962 4.962 0 0 1 1.128 1.164A7.967 7.967 0 0 0 20 12a8.008 8.008 0 0 0-8-8 8.008 8.008 0 0 0-8 8 7.965 7.965 0 0 0 1.887 5.156 4.994 4.994 0 0 1 1.129-1.166A4.966 4.966 0 0 1 10 15Z",
    fill: "#35272a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 12",
    d: "M12 6a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm0 6a2 2 0 1 0-2-2 2 2 0 0 0 2 2Z",
    fill: "#35272a"
  })));
};

export default SvgIcoUser;